function newViewCategory() {
  return this.validator.input.category_id !== 'ADD_NEW';
}

export default {
  message: 'Add or select a category.',
  fn: newViewCategory
};
